import { storeConstants } from '@utils/constants';
import factory from '@helpers/storeFactories/factory';

import { apiServiceCampaigns } from '@api';
import normalize from '@/data/response/normalizeCampaign';

const STORE_NAME = 'campaigns';

/*
 * ALL makes the factory page through the endpoint, 100 rows at a time (the API's maximum),
 * until a page comes back short. If a page fails, the factory stops there: it keeps the rows
 * already fetched and raises the standard error toast.
 *
 * After a campaign is created or edited, the page that saved it (or Edit's Cancel) leaves a
 * `pendingSearch`: Campaigns, once it shows, runs that search, which lists every campaign with the
 * one just saved at the top. Its `sort` is null for the API's newest-created-first order (after a
 * create, GAP-1468, or Edit's Cancel, GAP-1498) and CAMPAIGNS_SORT.MODIFIED after an update
 * (GAP-1503).
 */
const store = factory.createStore(
    STORE_NAME,
    {
        get: apiServiceCampaigns.campaigns.get,
    },
    {
        actionsOptions: {
            get: {
                defaultOptions: {
                    refresh: false,
                    offset: 0,
                    limit: 100,
                },
                controlItems: storeConstants.ACTION_GET_CONTROL_ITEMS.ALL,
            },
        },
        normalizeItemFn: normalize,
    },
    {
        state: {
            pendingSearch: null,
        },
        mutations: {
            setPendingSearch(state, value) {
                state.pendingSearch = value;
            },
        },
        actions: {
            // { sort } to run once Campaigns shows, or null once it has run.
            setPendingSearch({ commit }, value) {
                commit('setPendingSearch', value);
            },
        },
    }
);

export default store;
